import { render } from "./Quote.vue?vue&type=template&id=544ec926"
const script = {}
script.render = render

export default script